import NewsList from './NewsList';

export { NewsList };
export default NewsList;
